/* eslint-disable react/no-deprecated */

/**
 * We are disabling the react/no-deprecated,
 * because the bellowing code is used in integration,
 * and we are not ready yet to upgrade to ES 6 syntax.
 */

import tsRest from 'ts-rest-client';
import TranslatorManager from 'ts-translate-js';
import cIf from 'classnames';

let React = require('react');
let tr = TranslatorManager.boundTR;
let PropTypes = require('prop-types');
let up = require('react-addons-update');

const createClass = require('create-react-class');

export const PasswordEditionPanel = createClass({
    displayName: "PasswordEditionPanel",

    propTypes: {},

    getInitialState(){
        return {
            userid: tsapp.user.pi,
            passwords:{
                oldPassword:"",
                newPassword: "",
                confirmNewPassword: ""
            },
            showPasswordEditionError: false,
            showPwdEdition: false,
            wrongOldPassword: false,
            fieldRequire: false
        };
    },

    handleOnEditProfile() {
         this.setState({showPwdEdition:true});
    },

    handleOnCancelEditProfile() {
         this.setState({showPwdEdition:false});
    },

    handleOnSavePassword() {
        this.setState({showPasswordEditionError: false, NotSamePassword: false, fieldRequire: false});
        let pswValidator = new RegExp(/[A-Z0-9]\w{5,11}/i);
        
        if (this.state.passwords.oldPassword == "" || this.state.passwords.newPassword == "" || this.state.passwords.confirmNewPassword == "") {
            this.setState({ showPasswordEditionError:true, fieldRequire: true});
        }
        else if(this.state.passwords.newPassword !== this.state.passwords.confirmNewPassword) {
            this.setState({ NotSamePassword: true});
        }
        else if(!pswValidator.test(this.state.passwords.newPassword)) {
            this.setState({InvalidPassword:true});
        }
        else {
            this.handleOnCompletePasswordModification();
        }
    },

    handleOnCompletePasswordModification() {
        this.setState({InvalidPassword: false, showPasswordEditionError:false, showPwdEdition:false, wrongOldPassword:false});

        this.updatePasswordRequest = tsRest.post("/profiles/byuser/" + this.state.userid + "/pwd", this.state.passwords);

        this.updatePasswordRequest
            .done(function(data){
                if(!data.modified) {
                    this.setState({
                        showPasswordEditionError:true,
                        showPwdEdition: true,
                        wrongOldPassword: true
                    });
                }
            }.bind(this), function(err) {
                this.setState({ ts: null });
                return tsRest.handleError(err);
            }.bind(this));
    },

    handleOnModifyPassword(passwords) {
        this.setState({passwords});
    },



    componentWillUnmount() {
        if (this.updatePasswordRequest != null) this.updatePasswordRequest.abort();
    },

    render() {

        let pwdEdition;

        if (this.state.showPwdEdition)
            pwdEdition = <PasswordEdition   onModify={this.handleOnModifyPassword} 
                                            passwords={this.state.passwords} 
                                            onSave={this.handleOnSavePassword} 
                                            InvalidPassword={this.state.InvalidPassword} 
                                            NotSamePassword={this.state.NotSamePassword}
                                            showPasswordEditionError={this.state.showPasswordEditionError}
                                            wrongOldPassword={this.state.wrongOldPassword}
                                            fieldRequire={this.state.fieldRequire}
                                            onCancel={this.handleOnCancelEditProfile} />;
        else
            pwdEdition = <button onClick={this.handleOnEditProfile} className="btn btn-primary" >{tr("Modifier votre mot de passe")} <i className="fas fa-pencil-alt icon" aria-hidden="true"></i></button>;

        return (
            <div>
                <h3 className="panel-tab-header">{tr("Mot de passe")}</h3>
                {pwdEdition} 
                <div className="spacer-row"></div>
            </div>
        );
    }
});


const PasswordEdition = createClass({
    displayName: "PasswordEdition",

    propTypes: {
        passwords: PropTypes.shape({
            oldPassword: PropTypes.string,
            newPassword: PropTypes.string,
            confirmNewPassword: PropTypes.string
        }),
        onModify: PropTypes.func,
        onSave: PropTypes.func,
        onCancel: PropTypes.func
    },

    getInitialState(){
        return {
            userid: tsapp.user.pi,
            errorOnAction: "",
            showPasswordEditionError: false,
            InvalidPassword: false,
            fieldRequire:false
        };
    },

    handleOnChange(name, e){
        this.props.onModify(up(this.props.passwords, { [ name ]: { $set: e.target.value } }));
    },

    handleOnSave(e) {
        e.stopPropagation();
        e.preventDefault();
        this.props.onSave();
    },

    profileEditionErrorMessage(){
        let message = "";

        if (this.props.fieldRequire)
            message = tr("Ce champ est requis.");
        else if ( this.props.wrongOldPassword) 
            message = tr("Mauvais mot de passe.");
        else
            message = tr("Une erreur est apparue. Veuillez réessayer plus tard.");

        return (
            <div className="form-group">
                <div className="alert alert-danger text-center" style={{margin:"0"}} role="alert">{message}</div>
            </div>
        );
    },

    passwordValidatorErrorMessage() {
        let passwordErrorMessage = "";

        if(this.props.NotSamePassword)
            passwordErrorMessage = tr("Mots de passes différents");
        else if(this.props.InvalidPassword)
            passwordErrorMessage = tr("Veuillez saisir un mot de passe de 5 à 11 lettres et/ou chiffres");

        return (
            <span id="helpBlock" className="help-block"> {passwordErrorMessage} </span>
        );
    },

    handleOnCancelEdition() {
        this.props.onCancel();
    },
    
    render() {
        let passwordErrorMessage = null;
        let errorMessage = null;

        if (this.props.showPasswordEditionError)
        {
            errorMessage =  this.profileEditionErrorMessage();
        }

        passwordErrorMessage = this.passwordValidatorErrorMessage();

        return (
            <form onSubmit={this.handleOnSave}>
                <div className={cIf({"has-error":(this.props.oldPassword == "" || errorMessage != null) && this.props.showPasswordEditionError, "form-group":true})}>
                    <label htmlFor="inputPassword" className="control-label">{tr("Ancien mot de passe")}</label>
                    <input type="password" id="inputPassword" placeholder="******" className="form-control" maxLength={30} onChange={this.handleOnChange.bind(this,"oldPassword")}></input>
                </div>
                <div className={cIf({"has-error":(this.props.newPassword == "" || passwordErrorMessage != null || errorMessage != null) && (this.props.showPasswordEditionError || this.props.NotSamePassword), "form-group":true})}>
                    <label htmlFor="inputPassword" className="control-label">{tr("Nouveau mot de passe")}</label>
                    <input type="password" id="inputPassword" placeholder="******" className="form-control" maxLength={30} onChange={this.handleOnChange.bind(this,"newPassword")}></input>
                    {passwordErrorMessage}
                </div>
                <div className={cIf({"has-error":(this.props.cofirmNewPassword == "" || passwordErrorMessage != null || errorMessage != null) && (this.props.showPasswordEditionError || this.props.NotSamePassword), "form-group":true})}>
                    <label htmlFor="inputPasswordValidation" className="control-label">{tr("Confirmez votre nouveau mot de passe")}</label>
                    <input type="password" id="inputPasswordValidation" placeholder="******" maxLength={30} className="form-control" onChange={this.handleOnChange.bind(this,"confirmNewPassword")}></input>
                </div>
                    {errorMessage}
                <div className="btn-toolbar pull-right">
                    <button type="button" id="btnCancel" className="btn btn-default" onClick={this.handleOnCancelEdition}>{tr("Annuler")}</button>
                    <button type="submit" id="btnConfirm"  className="btn btn-primary">{tr("Confirmer")}</button>
                </div>
            </form>
        );
    }
});
